module.exports = __webpack_public_path__ + "static/media/banner.8c405fd7.png";